export default __webpack_public_path__ + "static/media/rnr-sports-table-19-cn.9cd960e4.webp";